export function validatePeriod(startDate, endDate, options = {}) {
    const {
        maxYearRange = null, // contoh: 1 → max 1 tahun
        allowCrossYear = true,
    } = options;

    if (!startDate || !endDate) {
        return {
            valid: false,
            message: "Tanggal awal dan akhir wajib diisi",
        };
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    // ❌ tanggal awal > akhir
    if (start > end) {
        return {
            valid: false,
            message: "Tanggal awal tidak boleh lebih besar dari tanggal akhir",
        };
    }

    // ❌ lintas tahun tidak diizinkan
    if (!allowCrossYear && start.getFullYear() !== end.getFullYear()) {
        return {
            valid: false,
            message: "Periode tidak boleh lintas tahun",
        };
    }

    // ❌ lebih dari N tahun
    if (maxYearRange !== null) {
        const yearDiff = end.getFullYear() - start.getFullYear();
        if (yearDiff > maxYearRange) {
            return {
                valid: false,
                message: `Periode maksimal ${maxYearRange} tahun`,
            };
        }
    }

    return { valid: true };
}
